import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Accordion,
  Card,
  FormControl,
  Form,
  CardGroup,
  CardDeck,
} from "react-bootstrap";
import api from "../../api";
import axios from "axios";
import Switch from "react-switch";

export default class BotSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id:"5f625d6abe11c328fca3d35d",
      queries: [],
      isLoading: false,
      fb_bot_status: true,
      yelp_bot_status: false,
      wa_bot_status: false,
    };
    this.changeBotStatus = this.changeBotStatus.bind(this);
    this.respondInput = React.createRef();
    this.onChangeResponse = this.onChangeResponse.bind(this);
  }

  changeBotStatus= async (fb_bot_status) => {
    // this.setState({ isLoading: true });
    this.setState({fb_bot_status});          
    //this.setState({checked: !this.state.checked});       
    // this.setState(prevState => ({
    //   checked: !prevState.checked
    // }));

    //console.log("Status:",this.state)
   var payload ={fb_bot:this.state.fb_bot_status};
   

    await api
    .updateBusinessByID(this.state._id, payload)
    .then((res) => {
      console.log("res:",res)
      this.setState({ isLoading: true });
    });
};

  

  componentDidMount = async () => {
    this.setState({ isLoading: true });

    // await api.getAllQueries().then((queries) => {
    //   this.setState({
    //     queries: queries.data.data,
    //     isLoading: false,
    //   });
    // });
  };

  onChangeResponse(e) {
    const id = parseInt(e.target.id);
    const response_text = e.target.value.toString();
    this.state.queries[id].reply = response_text;
  }

  handleResponse = async (id) => {
    this.setState({ isLoading: true });

    const fb_api =
      "https://graph.facebook.com/v6.0/me/messages?access_token=EAAkanQFH5mQBAGC1ltDXQbWybh9INAgdB0obMtFZCscOUsVaXWw4OJCZCFKOQzPw33GuZCM0yLBFaYzMIOZBOINOUMMpd9GUWExGXlkdL3uXGJBcEfDLJdM80iZC62MZAPKGeaOrftCSyxV1i16FyBQYYjrwB8qE6y6U4OIweyNwZDZD";
    axios.post(fb_api, {
      messaging_type: "RESPONSE",
      recipient: {
        id: this.state.queries[id].fb_recipient_id,
      },
      message: {
        text: this.state.queries[id].reply,
      },
    });

    await api
      .updateQueryById(this.state.queries[id]._id, {
        reply: this.state.queries[id].reply,
      })
      .then((res) => {
        this.setState({ isLoading: true });
      });
  };

  render() {
    const queries = this.state.queries;
    return (
      <div className="gs-container">
        <CardDeck>
          <Card>
            <div className="d-flex bot-logo">
              <img src="images/fb_logo-256x256.png" className="img-fluid" />
            </div>
            <Card.Body>
              <Card.Title>Facebook Bot</Card.Title>
              <Card.Text className="text-muted">
                It takese care of your business process via facebook messenger.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <Row className="">
                <Col sm="auto">
                  <label className="text-muted">Activation status:</label>
                </Col>
                <Col >
                  <label  >
                    <span></span>
                    <Switch className="pull-right"
                      onChange={this.changeBotStatus}
                      checked={this.state.fb_bot_status}
                    />
                  </label>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
          <Card>
            <div className="d-flex bot-logo">
              <img src="images/yelp_logo-256x256.png" className="img-fluid" />
            </div>
            <Card.Body>
              <Card.Title>Yelp Bot</Card.Title>
              <Card.Text className="text-muted">
                It takese care of your business process via yelp.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <Row className="">
                <Col sm="auto">
                  <label className="text-muted">Activation status:</label>
                </Col>
                <Col >
                  <label  >
                    <span></span>
                    <Switch className="pull-right"
                      onChange={this.changeBotStatus}
                      checked={this.state.yelp_bot_status}
                    />
                  </label>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
          <Card>
            <div className="d-flex bot-logo">
              <img src="images/wa_logo-256x256.png" className="img-fluid" />
            </div>
            <Card.Body>
              <Card.Title>Whatsapp Bot</Card.Title>
              <Card.Text className="text-muted">
                It takese care of your business process via whatsapp messenger.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <Row className="">
                <Col sm="auto">
                  <label className="text-muted">Activation status:</label>
                </Col>
                <Col >
                  <label  >
                    <span></span>
                    <Switch className="pull-right"
                      onChange={this.changeBotStatus}
                      checked={this.state.wa_bot_status}
                    />
                  </label>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
         
        </CardDeck>
      </div>
    );
  }
}
